import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 2560.000000 2560.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,2560.000000) scale(0.100000,-0.100000)">
<path d="M7901 6144 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M14391 5455 c-283 -72 -440 -284 -402 -541 14 -96 48 -160 119 -225
89 -81 199 -126 492 -198 278 -70 355 -116 367 -224 17 -149 -117 -238 -360
-237 -171 1 -348 50 -485 134 l-70 43 -25 -56 c-73 -157 -78 -173 -66 -188 42
-50 235 -131 390 -164 121 -25 342 -30 449 -10 190 35 344 131 415 259 87 155
71 365 -36 486 -88 98 -182 139 -505 221 -223 57 -247 65 -307 104 -60 38 -80
80 -75 156 3 53 9 71 34 102 109 138 436 149 701 23 l82 -38 46 114 c25 64 43
120 39 126 -8 13 -131 69 -199 91 -167 54 -439 63 -604 22z"/>
<path d="M6660 4630 l0 -831 458 3 c438 4 461 5 547 27 161 41 304 121 407
227 74 76 89 96 131 174 132 243 124 597 -18 830 -112 181 -280 303 -510 368
-89 25 -94 25 -552 29 l-463 5 0 -832z m947 538 c204 -73 328 -210 369 -408
30 -143 2 -322 -69 -442 -53 -89 -163 -179 -269 -217 -92 -34 -164 -41 -420
-41 l-248 0 0 571 0 571 283 -4 c274 -4 284 -4 354 -30z"/>
<path d="M9092 5413 c-11 -27 -44 -100 -72 -163 -29 -63 -62 -137 -75 -165
-12 -27 -53 -117 -90 -200 -37 -82 -78 -173 -90 -201 -13 -27 -41 -90 -63
-140 -40 -89 -170 -380 -276 -613 -31 -69 -56 -126 -56 -128 0 -2 70 -3 155
-3 146 0 155 1 165 21 11 20 72 163 128 297 l25 62 421 -2 421 -3 80 -187 80
-188 158 0 c86 0 157 2 157 4 0 10 -81 192 -265 596 -29 63 -69 153 -90 200
-20 47 -57 127 -81 178 -24 51 -44 95 -44 97 0 2 -35 82 -79 177 -43 95 -89
196 -101 223 -12 28 -36 80 -52 118 l-31 67 -152 0 -151 0 -22 -47z m228 -388
c28 -66 89 -209 135 -317 46 -109 91 -211 100 -227 32 -64 46 -61 -290 -61
-260 0 -305 2 -305 14 0 8 60 156 134 328 74 172 141 331 150 352 9 22 18 37
20 35 2 -2 27 -58 56 -124z"/>
<path d="M10080 5330 l0 -130 280 0 280 0 0 -700 0 -700 150 0 150 0 0 700 0
700 275 0 275 0 0 130 0 130 -705 0 -705 0 0 -130z"/>
<path d="M12115 5364 c-25 -54 -45 -99 -45 -101 0 -2 -43 -99 -96 -216 -239
-529 -277 -614 -364 -807 -51 -113 -114 -254 -141 -313 -27 -59 -49 -112 -49
-117 0 -6 63 -10 154 -10 l154 0 22 53 c12 28 49 114 82 190 l60 137 418 0
418 0 77 -182 c43 -101 81 -186 85 -191 4 -4 77 -6 163 -5 l156 3 -40 90
c-129 287 -226 501 -265 583 -24 51 -44 95 -44 98 0 2 -57 129 -126 281 -69
153 -132 292 -139 308 -8 17 -39 85 -69 153 -31 68 -56 127 -56 133 0 5 -64 9
-155 9 l-155 0 -45 -96z m265 -371 c35 -82 80 -188 101 -238 21 -49 60 -142
88 -205 27 -63 47 -118 45 -122 -8 -13 -614 -10 -614 3 0 5 25 67 56 136 31
70 64 147 74 172 69 175 171 401 180 401 4 0 36 -66 70 -147z"/>
<path d="M15573 4898 c3 -531 5 -567 24 -633 59 -203 158 -327 331 -414 183
-92 474 -101 690 -21 161 60 294 198 353 367 46 132 49 174 49 734 l0 529
-149 0 -150 0 -3 -547 c-4 -543 -4 -549 -27 -611 -46 -125 -108 -189 -226
-233 -80 -31 -242 -33 -325 -5 -131 44 -207 129 -244 273 -14 52 -16 141 -16
592 l0 531 -156 0 -155 0 4 -562z"/>
<path d="M17460 4630 l0 -831 518 3 c502 4 519 5 597 27 107 30 183 72 244
134 89 91 117 172 109 323 -3 73 -9 101 -35 154 -38 81 -108 151 -192 193 -64
31 -64 31 -40 47 135 87 206 250 181 413 -6 37 -21 88 -33 113 -52 103 -178
192 -324 229 -61 16 -131 19 -547 22 l-478 4 0 -831z m933 561 c68 -27 119
-76 135 -130 37 -123 -17 -230 -139 -276 -48 -18 -83 -20 -341 -23 l-288 -3 0
231 0 232 288 -4 c271 -4 290 -5 345 -27z m27 -687 c142 -33 200 -98 200 -223
0 -116 -42 -175 -155 -217 -44 -16 -90 -19 -377 -22 l-328 -3 0 240 0 241 298
0 c231 0 311 -4 362 -16z"/>

</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
